// extracted by mini-css-extract-plugin
export default {"uploadZone":"_08PhotoUploading_uploadZone__DbVxj","photoPreview":"_08PhotoUploading_photoPreview__Tp-aM"};